import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { normalizeCode } from "../../../lib/schemas/index.ts";

/** Reads the code from the card QR (`?c=CODE`); falls back to typed entry. */
export function useEntryCode(): { code: string; fromUrl: boolean; setCode: (v: string) => void } {
  const [params] = useSearchParams();
  const fromUrlRaw = params.get("c");
  const fromUrl = fromUrlRaw !== null && fromUrlRaw.trim() !== "";
  const [typed, setTyped] = useState("");
  const code = fromUrl ? normalizeCode(fromUrlRaw as string) : normalizeCode(typed);
  return { code, fromUrl, setCode: setTyped };
}
